import { format } from "date-fns";
import React from "react";
import { formatAmount } from "../../../../utils/format";
import { verifyCheckBoxes } from "../../../../utils/detail";
import FormTriggers from "../../../../layouts/FormTriggers";
import RadioButtons from "../../../../layouts/RadioButtons";

const CommonTrancheDetails = ({
  state,
  setState,
  formFieldState,
  handleRadioChange,
  handleTriggerChange,
  fieldValues,
  user,
  disableMaker,
  disable,
  disableRadioCls,
  cancelPartPaymentFunc,
}) => {
  const { caseDetails, stepDetails, checkpoints } = fieldValues;
  const checkerCheckpoints = checkpoints;
  const disbursedAmount = parseInt(caseDetails.net_disbursement_amount)
    ? caseDetails.net_disbursement_amount
    : caseDetails.lead_disbursed_amt
    ? caseDetails.lead_disbursed_amt
    : 0;

  const checkDisbursedAmount =
    checkerCheckpoints.disbursed_amount === "1" ? true : false;
  const uncheckdisbursedAmount =
    checkerCheckpoints.disbursed_amount === "0" ? true : false;
  const checkIsPartialPayment =
    checkerCheckpoints.is_partial_payment === "1" ? true : false;
  const checkWithheldAmount =
    checkerCheckpoints["with_held_amount"] === "1" ? true : false;
  const uncheckWithheldAmount =
    checkerCheckpoints["with_held_amount"] === "0" ? true : false;

  const openWithheldChargesModal = (e) => {
    if (e) e.preventDefault();
    const { sub_stage, is_reassigned, dts_pay_count } = caseDetails;
    const isEnabled =
      ["2", "3", "4", "12", "14"].includes(sub_stage) &&
      is_reassigned === 0 &&
      dts_pay_count === 1;
    setState((prevState) => ({
      ...prevState,
      showWithheldChargesModal: true,
      withHeldChargesInputDisabled: !isEnabled,
      withHeldChargesBtnDisplay: isEnabled,
      withHeldChargesOtherReasonDisplay: true,
      withHeldChargesAdjustmentChargesDisplay: false,
      withHeldChargesPayCount: 1,
      withHeldChargesAction: "manual",
      withHeldChargesAdjustmentAmount: formFieldState[0].disburse_bal_amt,
    }));
    if (e) e.stopPropagation();
  };
  return (
    <>
      <tr>
        <td>Financier</td>
        <td colSpan="2">
          {caseDetails.bank_name ? caseDetails.bank_name : ""}
          {" - "}
          <br />

          {caseDetails.disbursed_date &&
            `Disbursed on ${format(
              new Date(caseDetails.disbursed_date),
              "dd-MM-yyyy"
            )}`}
        </td>
      </tr>
      <tr>
        <td>LOS Id</td>
        <td colSpan="2">{caseDetails.bank_los_id}</td>
      </tr>
      <tr>
        <td width="30%">Net Amount</td>
        {!disableMaker ? (
          <td width="45%">
            <input
              type="hidden"
              value={`${disbursedAmount ? disbursedAmount : ""}`}
              name="disbursed_amount"
              placeholder="Enter Amount"
              className="form-control"
              readOnly
            />
            <span className="fa fa-inr"></span>
            {formatAmount(parseInt(disbursedAmount))}
          </td>
        ) : (
          <td>
            <span className="fa fa-inr"></span>
            {formatAmount(parseInt(disbursedAmount))}
          </td>
        )}
        {stepDetails.checklist && (
          <FormTriggers
            triggerName="disbursed_amount"
            disabled={disable}
            showYesButton={
              verifyCheckBoxes(caseDetails, user.dts_user) ||
              checkDisbursedAmount
            }
            showNoButton={
              verifyCheckBoxes(caseDetails, user.dts_user) ||
              uncheckdisbursedAmount
            }
            triggerValues={checkerCheckpoints}
            caseDetails={caseDetails}
            errorClass={
              state.showDisbursedAmountTriggerError ? "has-error" : ""
            }
            handleTriggerChange={handleTriggerChange}
          />
        )}
      </tr>
      <tr>
        <RadioButtons
          label="Is Partial ?"
          isRequired={false}
          className={`btn tog-btn tog-positive partial-payment ${
            +state.isPartialPayment === 1 ? "active" : ""
          }`}
          name="is_partial_payment"
          disabled={disableMaker}
          yesChecked={+state.isPartialPayment === 1 ? true : false}
          noChecked={parseInt(state.isPartialPayment) === 0 ? true : false}
          noButtonClassName={`btn tog-btn tog-negative partial-payment ${
            parseInt(state.isPartialPayment) !== 1 ? "active" : ""
          }`}
          showDiv={true}
          DivClassName={`btn-group toggle-option ${disableRadioCls}`}
          isStyledButton={true}
          onYesClicked={() => {
            handleRadioChange("1", -1, "isPartialPayment");
            openWithheldChargesModal(null);
          }}
          onNoClicked={() => {
            handleRadioChange("0", -1, "isPartialPayment");
            cancelPartPaymentFunc();
          }}
        />
        {stepDetails.checklist && (
          <FormTriggers
            triggerName="is_partial_payment"
            disabled={disable}
            showYesButton={
              verifyCheckBoxes(caseDetails, user.dts_user) ||
              checkIsPartialPayment
            }
            showNoButton={
              verifyCheckBoxes(caseDetails, user.dts_user) ||
              (uncheckdisbursedAmount && !checkIsPartialPayment)
            }
            triggerValues={checkerCheckpoints}
            caseDetails={caseDetails}
            errorClass={
              state.showIsPartialPaymentTriggerError ? "has-error" : ""
            }
            handleTriggerChange={handleTriggerChange}
          />
        )}
      </tr>
      {+state.isPartialPayment === 1 ? (
        <tr id="partial_payment_reason_id_tr">
          <td>Current Withheld Charges</td>
          <td>
            <div className="details-info rcm-issue-container with-held-charges">
              <span className="fa fa-inr"></span>
              <span id="with-held-charges">
                {formatAmount(parseInt(state.withHeldAmount))}
              </span>
              {caseDetails.dts_bal_amt !== 0 && (
                <button
                  className="ic_info rcm-issue-button"
                  title="WithheldCharges"
                  onClick={(e) => openWithheldChargesModal(e)}
                >
                  <img
                    src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                    alt=""
                  />
                </button>
              )}
            </div>
          </td>
          {stepDetails.checklist && (
            <FormTriggers
              triggerName="with_held_amount"
              disabled={disable}
              showYesButton={
                verifyCheckBoxes(caseDetails, user.dts_user) ||
                checkWithheldAmount
              }
              showNoButton={
                verifyCheckBoxes(caseDetails, user.dts_user) ||
                uncheckWithheldAmount
              }
              triggerValues={checkerCheckpoints}
              caseDetails={caseDetails}
              errorClass={
                state.showWithheldAmountTriggerError ? "has-error" : ""
              }
              handleTriggerChange={handleTriggerChange}
            />
          )}
        </tr>
      ) : (
        ""
      )}
    </>
  );
};

export default CommonTrancheDetails;
